import { Globe } from "lucide-react";

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <span className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-blue to-brand-turquoise flex items-center justify-center shadow-md">
      <Globe className="w-5 h-5 text-white" />
    </span>
    <span className="text-xl font-extrabold tracking-tight leading-none">
      <span className={light ? "text-white" : "text-brand-navy"}>NEX</span>
      <span className="text-brand-turquoise">A</span>
    </span>
  </span>
);
